import * as _ from "lodash";
import request from "@/utils/request";
import base_ds from "@/services/base_datasource_service";
import { AxiosResponse } from "axios";
import { IResponseResult } from "@/services/data/base_types";
import {AcceptChangeSchema, AcceptData, AcceptDataBackend} from "./models-service";

const route_ns = `email_template`;

class EmailTemplateService {

    data_source = base_ds.getBaseDataSource(route_ns);
    public crud = base_ds.getBaseCrud(route_ns);

    public current: any = {
      id: null,
      name: '',
      content: '',
    };


  constructor() {
    //
  }


  resetCurrent() {
    this.current = {
      id: null,
      name: '',
      content: '',
    };
  }

  empty() {

  }

}

export default new EmailTemplateService();
